import { roundDownToDecimals } from '@djs/number';

type FormatedPrice = { formatedValue: string; value: number };

type PriceFormatter = (price: number) => FormatedPrice;

export const knownCurrencies = new Set(['RUB', 'BYN', 'KZT', 'USD', 'EUR', 'GBP', 'votes', 'okcoins']);
const fractionCurrencies = new Set(['USD', 'EUR', 'GBP']);

/**
 * Рассчитывет объем скидки, возвращает округленное значение в процентах
 * @param basePrice старая цена
 * @param price актуальная цена
 */
export const getDiscountPercentValue = (basePrice: number, price: number) => {
  return Math.round(100 - (price / basePrice) * 100);
};

/**
 * Рассчитывает старую цену на основе актуальной цены и скидки (в процентах).
 * @param price актуальная цена
 * @param discount объем скидки
 */
export const getBasePriceByDiscount = (price: number, discount: number) => {
  return price / (1 - discount / 100);
};

/**
 * Рассчитывает новую цену на основе актуальной цены и скидки (в процентах).
 * @param price актуальная цена
 * @param discount объем скидки
 */
export const getDiscountedPrice = (price: number, discount: number) => {
  return price - (price * discount) / 100;
};

export const getPriceFormatterByCurrency = (
  translate: (key: string, params: Record<string, any>) => string,
  currency: string,
) => {
  if (knownCurrencies.has(currency)) {
    return (price: number, priceFormatter: PriceFormatter) => {
      const { formatedValue, value } = priceFormatter(price);

      return translate(`price_${currency}`, { amount: formatedValue, count: value });
    };
  }

  return (price: number, priceFormatter: PriceFormatter) => `${priceFormatter(price).formatedValue} ${currency}`;
};

export const getPriceFormatterByFraction =
  (currency: string, delimiter: string, separator: string) =>
  (price: number): FormatedPrice => {
    if (fractionCurrencies.has(currency)) {
      const roundedPrice = roundDownToDecimals(price, 2);

      return { formatedValue: formatNumber(roundedPrice.toFixed(2), delimiter, separator), value: roundedPrice };
    }

    const roundedPrice = Math.round(price);

    return { formatedValue: formatNumber(String(roundedPrice), delimiter, separator), value: roundedPrice };
  };

// Аналогично L.format.number, но с другими типами
const formatNumber = (price: string, delimiter: string, separator: string) => {
  const parts = price.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
  return parts.join(separator);
};
